module.exports = __webpack_public_path__ + "static/media/pikto_mysli.15da0928.png";